<template>
  <div>
    <v-container>
      <v-layout class="mb-4">
        <v-flex>
          <h3 class="headline mt-0">{{ $t('Shop address') }}</h3>
        </v-flex>
      </v-layout>
      <template v-if="['foodguru', 'cityfresh'].includes(selectedBot.theme)">
        <FoodguruShippingAddress> </FoodguruShippingAddress>
      </template>

      <template v-else>
        <shipping-address
          :is-edit="isEditShippingAddress"
          :init="contents"
          @onSave="isEditShippingAddress = false"
        ></shipping-address>
      </template>
    </v-container>
    <v-divider />
    <v-container>
      <v-layout wrap class="mb-4">
        <v-flex xs9>
          <h3 class="headline mt-0">{{ $t('Shipping Method') }}</h3>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <v-btn
            v-if="!isEditPaymentDetail"
            fab
            outline
            small
            color="primary"
            @click="isEditPaymentDetail = true"
          >
            <em class="fa fa-pencil-alt middle" />
          </v-btn>
        </v-flex>
      </v-layout>
      <shipping-detail
        :is-edit="isEditPaymentDetail"
        :init="contents"
        @onSave="isEditPaymentDetail = false"
      ></shipping-detail>
    </v-container>
    <v-divider />

    <!-- Shippop -->
    <template v-if="['foodguru'].includes(selectedBot.theme)">
      <v-container>
        <div style="border-radius: 15px; border: 1px solid #eee; overflow: hidden">
          <v-layout wrap>
            <v-flex
              xs12
              sm6
              style="
                background: url(../static/img/shippop.png);
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                min-height: 200px;
              "
            >
            </v-flex>
            <v-flex xs12 sm6 class="text-xs-center px-2 py-4">
              <v-layout justify-center align-center row style="height: 100%">
                <v-flex>
                  <div class="headline">ขายสินค้าต่อเนื่องแบบไม่มีสะดุด</div>
                  <div class="mb-2">SHIPPOP X ZWIZ.AI</div>
                  <v-btn depressed color="primary" large @click="gotoshippop"> ดูรายละเอียด </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-container>

      <v-container id="shippop">
        <shippop-manage></shippop-manage>
      </v-container>
    </template>

    <template v-if="['foodguru'].includes(selectedBot.theme)">
      <v-container id="zortout">
        <ZortOutManage></ZortOutManage>
      </v-container>
    </template>

    <template v-if="selectedBot.pagetype !== 'enterprise'">
      <v-divider></v-divider>
      <v-container>
        <akita-manage></akita-manage>
      </v-container>
    </template>

    <v-divider />
    <v-container>
      <JandtManage />
    </v-container>

    <div style="height: 60px"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

import ShippingDetail from '@/components/view/setting/ecommerce/ShippingDetail'
import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'
import FoodguruShippingAddress from '@/components/view/template/foodguru/ShippingAddress'
import ZortOutManage from '@/components/view/setting/ecommerce/ZortOutManage'
import ShippopManage from './ShippopManage'
import AkitaManage from './AkitaManage'
import JandtManage from './JandtManage'

export default {
  components: {
    ShippingDetail,
    ShippopManage,
    AkitaManage,
    ShippingAddress,
    FoodguruShippingAddress,
    ZortOutManage,
    JandtManage
  },
  data() {
    return {
      isEditShippingAddress: false,
      isEditPaymentDetail: false,
      isTransfer: false,
      isCreditCard: false,
      contents: []
    }
  },
  mounted() {
    this.getSetting()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    gotoshippop() {
      this.$el.querySelector('[id="shippop"]').scrollIntoView()
    },
    getSetting: function () {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getSetting(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.contents = {}
        if (response.data) {
          response.data.map(function (setting) {
            vm.contents[setting.contenttype] = setting
            if (setting.contenttype === 'allowtransfer') {
              vm.isTransfer = setting.contentvalue
            }
            if (setting.contenttype === 'allowcreditcard') {
              vm.isCreditCard = setting.contentvalue
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippingMethod.vue